/**
 * This file is a re-export of the EditPatientProfile component from the patient directory.
 * It exists for backward compatibility with existing imports.
 */
import EditPatientProfile from './patient/EditPatient'

export default EditPatientProfile
